/**
 * @file JS - Controller - LayoutPageController.js
 * @author : Adam Lemire
 * @since 2021/09/20
 * @version 1.0
 * @summary Dernières modifications : 2021/11/22
 */

import SingleMapPage from '../../classes/Page/SingleMapPage';
import { Evenements } from '../../events/Evenements';
import html2canvas from 'html2canvas';

require('jquery-ui/ui/core');
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/themes/base/accordion.css');
require('jquery-ui/themes/base/theme.css');

export default class LayoutPageController {
  constructor () {
    this._pageCarte = undefined;
    this._pageLayout = undefined;
    this._pageLayoutEstVisible = false;
  }

  get pageLayout () {
    return this._pageLayout;
  }

  activer () {
    this._ecouterBoutonFermer();
    this._initialiserMenuGaucheAccordeon();
  }

  /**
   * @param { SingleMapPage } pageCarte
   */
  async afficherPlanExportation (pageCarte) {
    this._pageCarte = await pageCarte;
    const mPageCarte = await this._pageCarte;

    $('.export-layout').show();
    this._pageLayoutEstVisible = true;
    if (mPageCarte instanceof SingleMapPage) {
      this._pageLayout = mPageCarte.layoutPage;
      $(mPageCarte.layoutPage.idLayout).show();
      mPageCarte.changeTarget(mPageCarte.layoutPage.apercuCarte);
      mPageCarte.layoutPage.olMap = mPageCarte.olMap;
      mPageCarte.setTemporaryView(mPageCarte.layoutPage.olView);
      mPageCarte.refreshMap();
      this._ecouterBoutonPNG(mPageCarte.layoutPage);
      this._ecouterBoutonAjouterTexte(mPageCarte.layoutPage);
      this._ecouterBoutonAjouterLegende(mPageCarte.layoutPage);
      this._ecouterBoutonReinitialiser(mPageCarte.layoutPage);
      this._viderMenuEdition();
      this._creerMenuEditionElementsExistants(mPageCarte.layoutPage);
      this._rafraichirContenuCarte(mPageCarte.layoutPage);
    }
  }

  exporterCarte () {
    this.exporterVersPNG();
  }

  _ecouterBoutonFermer () {
    const _this = this;
    $('.export-layout__close-button').on('click tap', function () {
      _this.fermerMiseEnForme();
    });
  }

  /** @param { LayoutPage } pageLayout */
  _ecouterBoutonAjouterTexte (pageLayout) {
    const _this = this;
    $('.export-layout__text-button').off('click tap');
    $('.export-layout__text-button').on('click tap', function () {
      _this._ajouterElementTexte(pageLayout);
    });
  }

  /** @param { LayoutPage } pageLayout */
  _ecouterBoutonAjouterLegende (pageLayout) {
    const _this = this;
    $('.export-layout__legend-button').off('click tap');
    $('.export-layout__legend-button').attr('disabled', false);
    $('.export-layout__legend-button').on('click tap', function () {
      _this._ajouterElementLegende(pageLayout);
    });
  }

  /** @param { LayoutPage } pageLayout */
  async _ecouterBoutonReinitialiser (pageLayout) {
    const mPageCarte = await this._pageCarte;
    $('.export-layout__reset-button').off('click tap');
    $('.export-layout__reset-button').on('click tap', function () {
      const layoutElementsJQ = pageLayout.idLayout + ' .layout__element';
      const conteneurEditeurJQ = '.conteneur__editeur-element';
      const menusContextuelJQ = '.context-menu-editeur-element';

      $(layoutElementsJQ).remove();
      $(conteneurEditeurJQ).empty();
      $(menusContextuelJQ).remove();
      $('.export-layout__legend-button').attr('disabled', false);
      mPageCarte.resetTarget();
      pageLayout.reinitialiser();
      mPageCarte.changeTarget(mPageCarte.layoutPage.apercuCarte);
      mPageCarte.setTemporaryView(mPageCarte.layoutPage.olView);
      mPageCarte.refreshMap();
    });
  }

  _ecouterBoutonPNG () {
    const _this = this;
    const boutonPNG = this._pageCarte.layoutPage.idLayout + ' .export-layout__png-button';
    $(boutonPNG).off('click tap').on('click tap', () => _this.exporterVersPNG());
  }

  async fermerMiseEnForme () {
    if (this._pageLayoutEstVisible) {
      const pageCarte = await this._pageCarte;
      if (pageCarte) {
        pageCarte.resetTarget();
      }
      $('.export-layout').hide();
      $('.layout-page').hide();
      this._pageLayoutEstVisible = false;
      Evenements.fermetureMiseEnForme.notify();
    }
  }

  /** @param { LayoutPage } pageLayout */
  _ajouterElementTexte (pageLayout) {
    if (pageLayout) {
      pageLayout.ajouterElementTexte();
    }
  }

  /** @param { LayoutPage } pageLayout */
  _ajouterElementLegende (pageLayout) {
    if (pageLayout) {
      pageLayout.ajouterElementLegende();
    }
  }

  /** @param { LayoutPage } pageLayout */
  _rafraichirContenuCarte (pageLayout) {
    pageLayout.rafraichirContenuCarte();
  }

  exporterVersPNG () {
    const _this = this;
    const olMap = this._pageCarte.olMap;
    const layoutPage = this._pageCarte.layoutPage;
    const conteneurCarte = 'export-layout__preview-map-' + layoutPage.id;

    console.log('exporterVersPNG');

    olMap.once('rendercomplete', function () {
      html2canvas(document.getElementById(conteneurCarte)).then(function (mapCanvas) {
        if (navigator.msSaveBlob) {
          // link download attribute does not work on MS browsers
          const nomFichierPNG = _this._pageCarte.layoutPage.nomFichier + '.png';
          navigator.msSaveBlob(mapCanvas.msToBlob(), nomFichierPNG);
        } else {
          const idLienTelechargement = 'download-png-' + layoutPage.id;
          const link = document.getElementById(idLienTelechargement);
          if (link) {
            link.href = mapCanvas.toDataURL();
            link.click();
          }
        }
      });
    });
    olMap.renderSync();
  }

  _initialiserMenuGaucheAccordeon () {
    $('.conteneur__editeur-element').accordion({
      heightStyle: 'content'
    });
  }

  _viderMenuEdition () {
    $('.conteneur__editeur-element').empty();
    $('.conteneur__editeur-element').accordion('refresh');
  }

  /** @param { LayoutPage } pageLayout */
  _creerMenuEditionElementsExistants (pageLayout) {
    if (pageLayout) {
      pageLayout.creerMenuEditionElementsExistants();
    }
  }

  /*
    <label for="export-layout__select-size">Dimensions:</label>
    <select name="export-layout__select-size" id="export-layout__select-size" class="export-layout__select-size">
      <option value="1080x720">1080 x 720 pixels</option>
      <option value="1280x720">1280 x 720 pixels</option>
      <option value="1920x1080">1920 x 1080 pixels</option>
      <option value="1080x1080">1080 x 1080 pixels</option>
      <option value="640x360">640 x 360 pixels</option>
    </select>
  */

  /*
  // cettte version n incluait pas légende, texte et bordure
  _exporterVersPNG () {
    const _this = this;
    const olMap = this._pageCarte.olMap;
    const layoutPage = this._pageCarte.layoutPage;

    olMap.once('rendercomplete', function () {
      const mapCanvas = document.createElement('canvas');
      const size = olMap.getSize();
      mapCanvas.width = size[0];
      mapCanvas.height = size[1];
      const mapContext = mapCanvas.getContext('2d');
      const selecteurCanvas = layoutPage.idLayout + ' .export-layout__preview-map canvas';
      const canvas = document.querySelector(selecteurCanvas);

      if (canvas.width > 0) {
        const opacity = canvas.parentNode.style.opacity;
        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
        const transform = canvas.style.transform;
        // Get the transform parameters from the style's transform matrix
        const matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number); // eslint-disable-line
        // Apply the transform to the export map context
        mapContext.setTransform(matrix);
        mapContext.drawImage(canvas, 0, 0);
      }

      if (navigator.msSaveBlob) {
        // link download attribute does not work on MS browsers
        const nomFichierPNG = _this._pageCarte.layoutPage.nomFichier + '.png';
        navigator.msSaveBlob(mapCanvas.msToBlob(), nomFichierPNG);
      } else {
        const idLienTelechargement = 'download-png-' + layoutPage.id;
        const link = document.getElementById(idLienTelechargement);
        if (link) {
          link.href = mapCanvas.toDataURL();
          link.click();
        }
      }
    });
    olMap.renderSync();
  }
  */
}
